import _ from "lodash";

export const toUpperFirstCharacterAllWords = (dataString) => {
	// Set the first letter of each word to uppercase.
	// First set the whole word to lower case to clean the data.
	let postData = "";
	//check that only string is accepted
	if (dataString && typeof dataString === "string") {
		//Check the name has apostrophe(')
		//Clear the blank space after the apostrophe, if any
		//Set the letter after apostrophe to uppercase
		if (_.indexOf(dataString, "'") > -1) {
			let cleanName = dataString.replace("' ", "'");
			postData = _.map(cleanName.split("'"), _.upperFirst).join("'");
		} else {
			postData = _.capitalize(toLowerWholeWord(dataString));
		}
	}
	return postData;
};

export const toUpperFirstCharacterFirstWord = (dataString) => {
	// Set the first letter of the first word to uppercase.
	// First set the whole word to lower case to clean the data.
	let postData = "";
	if (dataString !== undefined) {
		postData = _.capitalize(toLowerWholeWord(dataString));
	}

	return postData;
};

export const toLowerWholeWord = (dataString) => {
	let postData = "";
	if (dataString !== undefined) {
		postData = _.toLower(dataString);
	}
	return postData;
};

export const toUpperWholeWord = (dataString) => {
	let postData = "";
	if (dataString !== undefined) {
		postData = _.toUpper(dataString);
	}
	return postData;
};

export const cleanStringData = (dataString) => {
	// Ensure we have a valid string value.
	// Note: an empty string is a valid string
	let sanitisedString = errorTypeMessageEnum.UNAVAILABLE;

	if (!dataString) {
		return sanitisedString;
	}
	return dataString;
};

export const isValidUrl = (urlData) => {
	var pattern = new RegExp(
		"^(https?:\\/\\/)?" + // protocol
			"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
			"((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
			"(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
			"(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
			"(\\#[-a-z\\d_]*)?$",
		"i"
	); // fragment locator
	return !!pattern.test(urlData);
};

export const formatPhoneNumber = (phoneNumberData) => {
	if (
		phoneNumberData === undefined ||
		phoneNumberData === errorTypeMessageEnum.UNAVAILABLE ||
		phoneNumberData.length < 1
	)
		return "";

	phoneNumberData = phoneNumberData.replace(/-/g, "").trim(); // Replace all occurrences of "-"
	let numberLength = phoneNumberData.length;
	let formatPhone = "";

	formatPhone =
		numberLength === 9
			? phoneNumberData.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
			: phoneNumberData.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");

	return formatPhone;
};

export const calculateDollarAmtForPercent = ({
	aoBalance,
	inputAmt,
	frequency,
}) => {
	if (!aoBalance || !inputAmt || !frequency) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}

	if (
		aoBalance === errorTypeMessageEnum.UNAVAILABLE ||
		inputAmt === errorTypeMessageEnum.UNAVAILABLE ||
		frequency === errorTypeMessageEnum.UNAVAILABLE
	) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}
	try {
		let aoBalanceAmt = parseFloat(aoBalance);
		let parsedInputAmt = parseFloat(inputAmt);
		let freq = frequency.replace(/-/g, "").toLowerCase();
		let freqValue = 1; //yearly

		//* added check on freq to ensure we always capture a frequency (if available)
		switch (freq) {
			case "monthly":
			case "month":
				freqValue = 12;
				break;
			case "quarterly":
			case "quarter":
				freqValue = 4;
				break;
			case "halfyearly":
			case "halfyear":
				freqValue = 2;
				break;
			case "annually":
			case "annual":
				freqValue = 1;
				break;
			default:
				return "";
		}

		let calculatedValue = (aoBalanceAmt * (parsedInputAmt / 100)) / freqValue;

		return calculatedValue;
	} catch (e) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}
};

//!!!! TODO: Calculate the Client
//!!!! Ongoing Adviser Service Fee.
export const calculateAdviserServiceFee = ({ inputAmt, frequency }) => {
	if (!inputAmt || !frequency) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}

	if (
		inputAmt === errorTypeMessageEnum.UNAVAILABLE ||
		frequency === errorTypeMessageEnum.UNAVAILABLE
	) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}
	try {
		let parsedInputAmt = parseFloat(inputAmt);
		let freq = frequency.replace(/-/g, "").toLowerCase();

		let freqValue = 1; //yearly

		//* added check on freq to ensure we always capture a frequency (if available)
		switch (freq) {
			case "monthly":
			case "month":
				freqValue = 12;
				break;
			case "quarterly":
			case "quarter":
				freqValue = 4;
				break;
			case "halfyearly":
			case "halfyear":
				freqValue = 2;
				break;
			case "annually":
			case "annual":
				freqValue = 1;
				break;
			default:
				return "";
		}

		let calculatedValue = parsedInputAmt / freqValue;

		return calculatedValue;
	} catch (e) {
		return errorTypeMessageEnum.UNAVAILABLE;
	}
};

export function formatMobileNumber(mobileNumber) {
	const numericOnly = mobileNumber.replace(/\D/g, "");
	if (numericOnly.length === 10) {
		const formattedNumber = [
			numericOnly.slice(0, 4),
			numericOnly.slice(4, 7),
			numericOnly.slice(7),
		].join(" ");
		return formattedNumber;
	}
	return mobileNumber; // Return unchanged if not a 10-digit number
}

export function formatMobileNumberMasked(mobileNumber) {
	const numericOnly = mobileNumber.replace(/\D/g, "");
	if (numericOnly.length >= 10) {
		const lastThreeDigit = numericOnly.slice(7);
		return `XXXX XXX ${lastThreeDigit}`;
	}
	return mobileNumber;
}

export function formatDate(date) {
	if (!(date instanceof Date) || isNaN(date)) {
		return "";
	}
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${day}/${month}/${year}`;
}

export function formatDateMonthyear(date) {
	if (!(date instanceof Date) || isNaN(date)) {
		return "";
	}
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${month}/${year}`;
}

export const formatMobileNumberfromOktaMasked = (phoneNumber) => {
	// Remove all non-digit characters from the input
	const cleanedNumber = phoneNumber.replace(/\D/g, "");
	if (cleanedNumber.length >= 3) {
		// Extract the last 3 digits using slice
		return `XXXX XXX ${cleanedNumber.slice(-3)}`;
	} else {
		return phoneNumber;
	}
};
